(function () {
  if (window.scPdpReady) return;
  window.scPdpReady = true;

  function mainButton() {
    return document.querySelector('product-info .product-form__submit');
  }

  function cartUi() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function addUrl() {
    return (window.routes && window.routes.cart_add_url) || '/cart/add';
  }

  function toneBands() {
    document.querySelectorAll('[data-scp-band]').forEach(function (band, i) {
      band.classList.toggle('scp-band--g', i % 2 === 1);
    });
  }

  function syncTeaser() {
    var host = document.querySelector('shopify-forms-embed');
    var el = host && host.shadowRoot && host.shadowRoot.getElementById('app-embed');
    if (!el) return;
    var bar = document.querySelector('[data-scp-float]');
    var hide = !!bar && bar.classList.contains('is-on') && window.innerWidth < 750 && /Teaser/.test(el.className);
    if (hide) el.style.setProperty('visibility', 'hidden');
    else el.style.removeProperty('visibility');
  }

  function watchFloat() {
    var bar = document.querySelector('[data-scp-float]');
    if (!bar || !mainButton()) return;
    document.body.appendChild(bar);
    function update() {
      var btn = mainButton();
      bar.classList.toggle('is-on', !!btn && btn.getBoundingClientRect().bottom < 0);
      syncTeaser();
    }
    var queued = false;
    function queue() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        update();
      });
    }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    update();
  }

  var showView = null; // set by initViews: show a view's button as pressed and ignore passing slides

  function initViews() {
    var views = document.querySelector('[data-scp-views]');
    var info = document.querySelector('product-info');
    var gallery = info && info.querySelector('media-gallery');
    var viewer = gallery && gallery.querySelector('[id^="GalleryViewer"]');
    if (!views || !viewer || typeof gallery.setActiveMedia !== 'function') return;
    var section = info.dataset.section;
    var buttons = views.querySelectorAll('[data-scp-view]');
    var list = viewer.querySelector('ul');
    var target = null;
    var until = 0;
    if (list) list.after(views);
    else viewer.appendChild(views);
    if (getComputedStyle(viewer).position === 'static') viewer.style.position = 'relative';
    views.hidden = false;

    // Ignore slides passed on the way to a target.
    function expect(mediaId) {
      target = mediaId;
      until = Date.now() + 1500;
    }

    function press(mediaId) {
      var hit = false;
      buttons.forEach(function (b) {
        var on = !!b.dataset.scpView && section + '-' + b.dataset.scpView === mediaId;
        if (on) hit = true;
        b.setAttribute('aria-pressed', on);
      });
      if (!hit) buttons[0].setAttribute('aria-pressed', 'true');
    }

    views.addEventListener('click', function (event) {
      var b = event.target.closest('[data-scp-view]');
      if (!b) return;
      var first = viewer.querySelector('[data-media-id]');
      var id = b.dataset.scpView ? section + '-' + b.dataset.scpView : first && first.dataset.mediaId;
      if (!id) return;
      expect(id);
      press(id);
      gallery.setActiveMedia(id, false);
      // Phone slider: jump, don't scroll past photos.
      var media = list && list.querySelector('[data-media-id="' + id + '"]');
      if (media && list.scrollWidth > list.clientWidth + 1) {
        list.style.scrollBehavior = 'auto';
        list.scrollLeft = media.offsetLeft;
        requestAnimationFrame(function () {
          list.style.scrollBehavior = '';
        });
      }
    });
    gallery.addEventListener('click', function (event) {
      var t = event.target.closest('[data-target]');
      if (!t) return;
      expect(t.dataset.target);
      press(t.dataset.target);
    });
    viewer.addEventListener('slideChanged', function (event) {
      var current = event.detail && event.detail.currentElement;
      if (!current) return;
      var id = current.dataset.mediaId;
      if (target) {
        if (id !== target && Date.now() < until) return;
        target = null;
      }
      press(id);
    });
    showView = function (mediaId) {
      expect(mediaId);
      press(mediaId);
    };
  }

  // Picking a finish while the 3D model is on screen keeps the model there (init3d switches its finish) instead of
  // Dawn jumping to that finish's photo.
  function keep3d() {
    if (!window.customElements) return;
    customElements.whenDefined('product-info').then(function () {
      var Info = customElements.get('product-info');
      if (!Info || Info.prototype.scpKeep3d) return;
      Info.prototype.scpKeep3d = true;
      var update = Info.prototype.updateMedia;
      Info.prototype.updateMedia = function (html, id) {
        var gallery = this.querySelector('media-gallery');
        var model = gallery && showing3d(this, gallery);
        if (!model) return update.call(this, html, id);
        gallery.setActiveMedia = function () {};
        try {
          return update.call(this, html, id);
        } finally {
          delete gallery.setActiveMedia;
          stay(gallery, model);
        }
      };
    });
  }

  // The gallery slide holding the 3D model if it is the one on screen, else null.
  function showing3d(info, gallery) {
    var is3d = function (li) {
      return li && li.querySelector('model-viewer, product-model') ? li : null;
    };
    var active = is3d(gallery.querySelector('[id^="GalleryViewer"] li.is-active'));
    if (active) return active;
    var b = document.querySelector('[data-scp-view][aria-pressed="true"]');
    return b && b.dataset.scpView ? is3d(gallery.querySelector('[data-media-id="' + info.dataset.section + '-' + b.dataset.scpView + '"]')) : null;
  }

  // After Dawn reorders the slides for the new finish: keep the phone slider, the thumbnail and the view bar on the model.
  function stay(gallery, model) {
    var id = model.dataset.mediaId;
    var list = model.parentElement;
    if (list && list.scrollWidth > list.clientWidth + 1) {
      list.style.scrollBehavior = 'auto';
      list.scrollLeft = model.offsetLeft;
      requestAnimationFrame(function () {
        list.style.scrollBehavior = '';
      });
    }
    var thumbs = gallery.elements && gallery.elements.thumbnails;
    var thumb = thumbs && thumbs.querySelector('[data-target="' + id + '"]');
    if (thumb && typeof gallery.setActiveThumbnail === 'function') gallery.setActiveThumbnail(thumb);
    if (showView) showView(id);
  }

  // 3D viewer: in Room mode the model is shown mounted in a room (a scene copy of the model with the ceiling,
  // wall or sideboard it attaches to, and a room backdrop); Plain shows the clean model. The model follows the
  // chosen finish. AR keeps using the clean model.
  var SCENE_ORBIT = { ceiling: [15, 95], downlight: [15, 120], porch: [15, 105], wall: [25, 82], exterior: [25, 82], console: [20, 76] };
  // theta min, phi min, theta max, phi max, radius cap: keeps the camera inside the room and in front of the wall
  var SCENE_LIMITS = {
    ceiling: ['-Infinity', '88deg', 'Infinity', '130deg', 2.6],
    downlight: ['-Infinity', '95deg', 'Infinity', '150deg', 1.2],
    porch: ['-75deg', '92deg', '75deg', '140deg', 1.5],
    wall: ['-75deg', '50deg', '75deg', '118deg', 2.5],
    exterior: ['-75deg', '50deg', '75deg', '115deg', 2.5],
    console: ['-75deg', '35deg', '75deg', '88deg', 2.0],
  };
  var SCENE_ATTRS = ['camera-target', 'camera-orbit', 'field-of-view', 'min-camera-orbit', 'max-camera-orbit', 'shadow-intensity'];
  // Lights on: the room opens dark, then a few seconds later the lamp fades on and the room brightens.
  // Product brightness is the viewer exposure; the room surfaces are unlit, so they follow their colour factor.
  var LIGHT_DELAY = 1500;
  var LIGHT_FADE = 2600;
  var LIGHT_IN = { exposure: [0.25, 0.95], room: [0.06, 1] };
  var LIGHT_OUT = { exposure: [0.25, 0.7], room: [0.05, 1] };

  function lightLevel(mv, k, outdoor) {
    var l = outdoor ? LIGHT_OUT : LIGHT_IN;
    var r = l.room[0] + (l.room[1] - l.room[0]) * k;
    mv.exposure = l.exposure[0] + (l.exposure[1] - l.exposure[0]) * k;
    mv.dataset.scpLight = k;
    if (!mv.model) return;
    mv.model.materials.forEach(function (m) {
      if (m.isLoaded === false) return; // unselected finish variants throw until they load
      var n = m.name || '';
      var pb = m.pbrMetallicRoughness;
      if (n.indexOf('·bulb') > -1) m.setEmissiveFactor([k, 0.75 * k, 0.45 * k]);
      else if (n.indexOf('·filament') > -1) pb.setBaseColorFactor([0.3 + 0.7 * k, 0.22 + 0.71 * k, 0.13 + 0.65 * k, 1]);
      else if (n.indexOf('·halo') > -1) {
        var h = pb.baseColorFactor;
        pb.setBaseColorFactor([h[0], h[1], h[2], parseFloat((n.match(/a=([\d.]+)/) || [0, 0])[1]) * k]);
      } else if (n.indexOf('·glass') > -1) m.setEmissiveFactor([k, 0.78 * k, 0.5 * k]);
      else if (n.indexOf('·glow') > -1) m.setEmissiveFactor([k, 0.85 * k, 0.65 * k]);
      else if (n.indexOf('scene-') === 0 && n !== 'scene-contact-shadow') pb.setBaseColorFactor([r, r, r, 1]);
    });
  }

  function init3d() {
    var cfg = document.querySelector('[data-scp-3d]');
    var info = document.querySelector('product-info');
    if (!cfg || !info) return;
    var scene = cfg.dataset.scene;
    var kind = cfg.dataset.kind;
    var key = 'scpScenePlain';
    var current = null;
    var mount = null;
    try {
      mount = JSON.parse(cfg.dataset.scene3d || 'null');
    } catch (e) {}
    if (mount && (!mount.src || !SCENE_ORBIT[mount.kind])) mount = null;
    var lit = !!mount && mount.kind !== 'console'; // the table lamps are bases without a bulb
    var outdoor = !!mount && (mount.kind === 'exterior' || mount.kind === 'porch');
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null;
    var frame = null;

    function stopLights() {
      clearTimeout(timer);
      if (frame) cancelAnimationFrame(frame);
      timer = frame = null;
    }

    function lightsOn(mv) {
      stopLights();
      lightLevel(mv, 0, outdoor);
      timer = setTimeout(function () {
        if (calm) return lightLevel(mv, 1, outdoor);
        var t0 = performance.now();
        var step = function (now) {
          var t = Math.min(1, (now - t0) / LIGHT_FADE);
          lightLevel(mv, t * t * (3 - 2 * t), outdoor);
          frame = t < 1 ? requestAnimationFrame(step) : null;
        };
        frame = requestAnimationFrame(step);
      }, LIGHT_DELAY);
    }

    function hasRoom(mv) {
      return !!mv.model && mv.model.materials.some(function (m) {
        return (m.name || '').indexOf('scene-') === 0;
      });
    }

    function plain() {
      try {
        return window.localStorage.getItem(key) === '1';
      } catch (e) {
        return false;
      }
    }

    function norm(s) {
      return String(s || '').trim().toLowerCase();
    }

    function variant() {
      if (current) return current;
      var el = info.querySelector('[data-selected-variant]');
      try {
        return el ? JSON.parse(el.textContent) : null;
      } catch (e) {
        return null;
      }
    }

    function finish(mv) {
      var names = mv.availableVariants || [];
      var v = variant();
      if (!names.length || !v) return;
      var wants = [v.title, v.option1, v.option2, v.option3].filter(Boolean).map(norm);
      for (var i = 0; i < wants.length; i++) {
        for (var j = 0; j < names.length; j++) {
          if (norm(names[j]) === wants[i]) {
            if (mv.variantName !== names[j]) {
              mv.variantName = names[j];
              // a newly picked finish loads its own materials; give it the current light level
              if (lit && mv.dataset.scpLight) {
                [150, 700].forEach(function (ms) {
                  setTimeout(function () {
                    if (mv.getAttribute('src') === mount.src) lightLevel(mv, +mv.dataset.scpLight, outdoor);
                  }, ms);
                });
              }
            }
            return;
          }
        }
      }
    }

    function backdrop(mv) {
      var room = !plain();
      if (scene && room) mv.setAttribute('skybox-image', scene);
      else mv.removeAttribute('skybox-image');
      if (!mount) return;
      if (room) {
        var o = SCENE_ORBIT[mount.kind];
        var lim = SCENE_LIMITS[mount.kind];
        var r = mount.radius;
        var t = mount.target;
        mv.setAttribute('camera-target', t[0] + 'm ' + t[1] + 'm ' + t[2] + 'm');
        mv.setAttribute('field-of-view', mount.fov + 'deg');
        mv.setAttribute('min-camera-orbit', lim[0] + ' ' + lim[1] + ' ' + (r * 0.4).toFixed(3) + 'm');
        mv.setAttribute('max-camera-orbit', lim[2] + ' ' + lim[3] + ' ' + Math.min(r * 1.6, lim[4]).toFixed(3) + 'm');
        mv.setAttribute('camera-orbit', o[0] + 'deg ' + o[1] + 'deg ' + r.toFixed(3) + 'm');
        mv.setAttribute('shadow-intensity', '0');
        if (lit) mv.exposure = (outdoor ? LIGHT_OUT : LIGHT_IN).exposure[0];
        if (mv.getAttribute('src') !== mount.src) {
          mv.setAttribute('src', mount.src);
          // back to Room before the plain model finished loading: the room model stays and no load event comes
          if (lit) {
            setTimeout(function () {
              if (!plain() && mv.getAttribute('src') === mount.src && mv.dataset.scpLight === undefined && hasRoom(mv)) lightsOn(mv);
            }, 1500);
          }
        } else if (lit && mv.loaded) lightsOn(mv);
      } else {
        stopLights();
        mv.exposure = 1;
        delete mv.dataset.scpLight;
        SCENE_ATTRS.forEach(function (a) {
          mv.removeAttribute(a);
        });
        if (mv.dataset.scpSrc && mv.getAttribute('src') !== mv.dataset.scpSrc) mv.setAttribute('src', mv.dataset.scpSrc);
      }
    }

    function pressBars() {
      var on = plain() ? 'plain' : 'room';
      info.querySelectorAll('[data-scp-scene]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.scpScene === on);
      });
    }

    // finish swatches over the 3D view: each one picks that option in the product's own picker
    function pickerFor(name) {
      var radios = info.querySelectorAll('variant-selects input[type="radio"]');
      for (var i = 0; i < radios.length; i++) if (norm(radios[i].value) === norm(name)) return radios[i];
      var opts = info.querySelectorAll('variant-selects select option');
      for (var j = 0; j < opts.length; j++) if (norm(opts[j].value) === norm(name)) return opts[j];
      return null;
    }

    function pressFinish() {
      var v = variant();
      var have = v ? [v.title, v.option1, v.option2, v.option3].filter(Boolean).map(norm) : [];
      info.querySelectorAll('[data-scp-finish]').forEach(function (b) {
        b.setAttribute('aria-pressed', have.indexOf(norm(b.dataset.scpFinish)) > -1);
      });
    }

    function finishBar(mv) {
      var host = mv.closest('.product-media-container');
      if (!host || host.querySelector('.scp-finish')) return pressFinish();
      var names = (mv.availableVariants || []).filter(pickerFor);
      if (names.length < 2) return;
      var bar = document.createElement('div');
      bar.className = 'scp-finish';
      bar.setAttribute('role', 'group');
      bar.setAttribute('aria-label', 'Finish');
      names.forEach(function (n) {
        var el = pickerFor(n);
        var sw = el.labels && el.labels[0] && el.labels[0].querySelector('.swatch');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'scp-finish__sw';
        b.dataset.scpFinish = el.value;
        b.title = el.value;
        b.setAttribute('aria-label', el.value);
        if (sw && sw.getAttribute('style')) b.setAttribute('style', sw.getAttribute('style'));
        bar.appendChild(b);
      });
      host.appendChild(bar);
      pressFinish();
    }

    function setup(mv) {
      if (mv.dataset.scpReady) return;
      mv.dataset.scpReady = '1';
      mv.dataset.scpSrc = mv.getAttribute('src') || '';
      if (kind === 'console' && !mount) mv.setAttribute('shadow-intensity', '1');
      backdrop(mv);
      // outside .media: Dawn stretches every child of .media to fill it
      var host = mv.closest('.product-media-container');
      if (scene && host && !host.querySelector('.scp-scene')) {
        var bar = document.createElement('div');
        bar.className = 'scp-scene';
        bar.setAttribute('role', 'group');
        bar.setAttribute('aria-label', 'Backdrop');
        bar.innerHTML =
          '<button type="button" data-scp-scene="room">Room</button><button type="button" data-scp-scene="plain">Plain</button>';
        host.appendChild(bar);
        pressBars();
      }
      if (mv.loaded) {
        finish(mv);
        finishBar(mv);
      }
      mv.addEventListener('load', function () {
        if (lit && !plain() && mv.getAttribute('src') === mount.src) lightsOn(mv);
        finish(mv);
        finishBar(mv);
      });
    }

    function scan() {
      info.querySelectorAll('model-viewer').forEach(setup);
    }

    scan();
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].addedNodes.length) {
          scan();
          return;
        }
      }
    }).observe(info, { childList: true, subtree: true });

    info.addEventListener('click', function (event) {
      var f = event.target.closest('[data-scp-finish]');
      if (f) {
        event.preventDefault();
        event.stopPropagation();
        var el = pickerFor(f.dataset.scpFinish);
        if (!el || f.getAttribute('aria-pressed') === 'true') return;
        if (el.tagName === 'OPTION') {
          el.parentNode.value = el.value;
          el.parentNode.dispatchEvent(new Event('change', { bubbles: true }));
        } else el.click();
        info.querySelectorAll('[data-scp-finish]').forEach(function (x) {
          x.setAttribute('aria-pressed', x === f);
        });
        return;
      }
      var b = event.target.closest('[data-scp-scene]');
      if (!b) return;
      event.preventDefault();
      event.stopPropagation();
      try {
        if (b.dataset.scpScene === 'plain') window.localStorage.setItem(key, '1');
        else window.localStorage.removeItem(key);
      } catch (e) {}
      info.querySelectorAll('model-viewer').forEach(backdrop);
      pressBars();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var v = event.data && event.data.variant;
        if (v) current = v;
        info.querySelectorAll('model-viewer').forEach(finish);
        pressFinish();
      });
    }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var html = event.data && event.data.html;
      if (!html) return;
      document.querySelectorAll('[data-scp-sync]').forEach(function (el) {
        var src = html.querySelector('[data-scp-sync="' + el.dataset.scpSync + '"]');
        if (src) el.innerHTML = src.innerHTML;
      });
    });
  }

  document.addEventListener('click', function (event) {
    var floatAdd = event.target.closest('[data-scp-float-add]');
    if (floatAdd) {
      var btn = mainButton();
      if (btn && !btn.disabled) btn.click();
      return;
    }

    var quick = event.target.closest('[data-scp-quick-add]');
    if (!quick || quick.getAttribute('aria-busy') === 'true') return;
    var cart = cartUi();
    var body = { id: Number(quick.dataset.scpQuickAdd), quantity: 1 };
    if (cart && cart.getSectionsToRender) {
      body.sections = cart.getSectionsToRender().map(function (s) {
        return s.id;
      });
      body.sections_url = window.location.pathname;
      if (cart.setActiveElement) cart.setActiveElement(quick);
    }
    quick.setAttribute('aria-busy', 'true');
    fetch(addUrl() + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        if (res.status) {
          quick.textContent = 'Unavailable';
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sc-pdp', productVariantId: body.id, cartData: res });
        }
        if (cart && cart.renderContents) cart.renderContents(res);
        else window.location = window.routes ? window.routes.cart_url : '/cart';
      })
      .catch(function (e) {
        console.error(e);
      })
      .finally(function () {
        quick.removeAttribute('aria-busy');
      });
  });

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form.matches || !form.closest('product-info') || form.getAttribute('data-type') !== 'add-to-cart-form') return;
      if (form.dataset.scpBulb === 'done') {
        delete form.dataset.scpBulb;
        return;
      }
      var check = document.querySelector('product-info [data-scp-addon]');
      if (!check || !check.checked) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      var qtyInput = document.querySelector('product-info .quantity__input');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var submitter = event.submitter || form.querySelector('[type="submit"]');
      fetch(addUrl() + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(check.dataset.scpAddon), quantity: qty }] }),
      })
        .catch(function (e) {
          console.error(e);
        })
        .finally(function () {
          form.dataset.scpBulb = 'done';
          if (form.requestSubmit) form.requestSubmit(submitter);
          else submitter.click();
        });
    },
    true
  );

  function init() {
    toneBands();
    watchFloat();
    init3d();
    keep3d();
    if (window.customElements && customElements.whenDefined) customElements.whenDefined('media-gallery').then(initViews);
    else initViews();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', toneBands);
})();
